import { navItems } from "@/mocks/jiuse";

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6">
        <div className="flex flex-col gap-8 md:flex-row md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="grid h-9 w-9 place-items-center rounded-full bg-primary-600 text-lg text-background-50">
                <i className="ri-newspaper-line" aria-hidden="true" />
              </span>
              <span className="font-display text-xl font-bold text-foreground-950">
                九色黑料<span className="text-primary-600">网</span>
              </span>
            </div>
            <p className="mt-3 text-[13px] leading-6 text-foreground-600">
              九色黑料图片、九色黑料视频、九色黑料截图分区整理，点开即看原图级画面。想找截图、照片或视频细节，直接按页翻即可。
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <p className="text-xs font-semibold tracking-[0.2em] text-foreground-500">分区入口</p>
            <div className="grid grid-cols-2 gap-x-8 gap-y-2 sm:grid-cols-3">
              {navItems.map((it) => (
                <a key={it.href} href={it.href} className="flex items-center gap-1.5 whitespace-nowrap text-[13px] text-foreground-700 transition hover:text-primary-700">
                  <i className="ri-corner-down-right-line text-[12px] text-primary-500" aria-hidden="true" />
                  {it.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <p className="mt-8 border-t border-background-200 pt-4 text-center text-[11px] leading-5 text-foreground-500">
          本站内容仅为素材分区索引展示，浏览请遵守当地法律法规；相关画面版权归属原权利人，请勿用于商业用途。
        </p>
        <p className="mt-1 text-center text-[11px] text-foreground-400">© 2026 九色黑料网 · 每日更新 · 原图级画面持续流出中</p>
      </div>
    </footer>
  );
}